<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.5" />
  </svg>
</template>
